import { RootState } from '@/modules/ewwms/store';

import { GetterTree } from 'vuex';
import { State } from './state';
import { Bestellung } from '@/modules/ewwms/models/Lager/BestellungenModels';
import { Listeartikel } from '@/modules/ewwms/models/Lager/ListeartikelModels';
import { ArchivComponenteFile } from '@/modules/ewwms/models/ArchivModels';

export type Getters = {
  bestellungen(state: State): Array<Bestellung>;
  paletten(state: State): Array<Listeartikel>;
  initDate(state: State): Date;
  bestellungDoc(state: State): ArchivComponenteFile | null;
};

export const getters: GetterTree<State, RootState> & Getters = {
  bestellungen(state) {
    return state.bestellungen;
  },

  paletten(state) {
    return state.paletten;
  },

  initDate(state) {
    return state.initDate;
  },

  bestellungDoc(state) {
    return state.bestellungDoc;
  },
};
